module.exports = __webpack_public_path__ + "img/20191108155257889.5cf5cbc6.jpg";